var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/ranking"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ranking"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.4464 23.2486L17.6005 19.7862C17.7579 19.3141 17.653 18.5796 17.3557 18.1774L15.6157 15.738C14.5053 14.1729 15.1524 12.8964 17.0759 12.8964L20.3285 12.8963C20.8706 12.8963 21.5613 12.5204 21.8586 12.0482L23.4149 9.56506C24.639 7.60652 26.1079 7.83385 26.685 10.0722L27.4807 13.1936C27.6293 13.762 28.2064 14.339 28.7747 14.4876L31.8961 15.2833C34.1345 15.8604 34.3618 17.3293 32.4033 18.5534L29.9201 20.1097C29.4567 20.3982 29.0807 21.089 29.072 21.6398L29.072 24.8924C29.072 26.816 27.7867 27.4718 26.2303 26.3526L23.7909 24.6126C23.38 24.3241 22.6543 24.2104 22.1821 24.3678L18.7197 25.5219C16.8486 26.1515 15.8169 25.1198 16.4464 23.2486Z",
    fill: "#FFAA00",
    stroke: "#FFAA00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.6077 28.8542L17.4873 34.9746",
    stroke: "#FFAA00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.1141 18.362L6.99365 24.4824",
    stroke: "#FFAA00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.9904 27.9798L12.2417 29.7285",
    stroke: "#FFAA00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.6ed7613380d153d7409aac7cddb67aed.svg";
export { ForwardRef as ReactComponent };